import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";

export const Container = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  gap: 10,
  width: "300px",
  maxHeight: "200px",
  overflow: "auto",

  "& span, li": {
    fontSize: "14px",
  },

  "& ul": {
    margin: 0,
  },
});
